var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventsNavIcon = function SvgEventsNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.095,
    cy: 15.047,
    fill: "#813785",
    rx: 1.905,
    ry: 3.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#61A0C0",
    stroke: "#61A0C0",
    strokeWidth: 0.952,
    d: "M11.667 18.675v-7.619c3.429-.38 6.825-3.015 8.095-4.285 1.524-1.524 2.381-.476 2.381.476v15.238c0 1.428-1.428 1.428-2.38.476-1.905-2.667-6.191-3.968-8.096-4.286Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D270",
    d: "M5 12.485c0-1.052.853-1.904 1.905-1.904h4.762v8.571H6.905A1.905 1.905 0 0 1 5 17.247z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D270",
    stroke: "#F4D270",
    strokeWidth: 0.476,
    d: "M7.143 17.667h4.286v5.476c0 .395-.32.714-.715.714H7.857a.714.714 0 0 1-.714-.714z"
  })));
};
export default SvgEventsNavIcon;